import { IconMessage } from '@tabler/icons-react';
import {
  FeedbackState,
  PreSaleVisitFeedbackData,
} from '../hooks/usePreSaleVisitFeedback';
import {
  OBJECTION_OPTIONS,
  PROSPECT_STAGE_OPTIONS,
  PURCHASE_INTENT_OPTIONS,
  optionLabel,
} from '../constants/preSaleFeedbackOptions';
import { Field } from './VisitDetailParts';

interface Props {
  state: FeedbackState;
  feedback: PreSaleVisitFeedbackData | null;
  modelName?: string;
  // Sólo el Proper asignado puede registrar el feedback pendiente.
  onGiveFeedback?: () => void;
}

// "Feedback del Proper" del detalle de una asesoría finalizada.
const PreSaleFeedbackCard = ({
  state,
  feedback,
  modelName,
  onGiveFeedback,
}: Props) => (
  <section className="vd-card">
    <header className="vd-card__header">
      <span className="vd-icon vd-icon--green">
        <IconMessage size={20} />
      </span>
      <h2 className="vd-card__title">Feedback del Proper</h2>
      {state === 'done' && (
        <span className="vd-pill vd-pill--success ml-auto">Completado</span>
      )}
      {state === 'pending' && (
        <span className="vd-pill vd-pill--warning ml-auto">Pendiente</span>
      )}
    </header>

    {state === 'loading' && <p className="mb-0 text-muted">Cargando…</p>}
    {state === 'error' && (
      <p className="mb-0 text-muted">No se pudo cargar el feedback.</p>
    )}
    {state === 'pending' && (
      <>
        <p className="vd-locked__text">
          Todavía no se registra el feedback de esta asesoría.
        </p>
        {onGiveFeedback && (
          <div className="vd-actions">
            <button
              type="button"
              className="vd-btn vd-btn--primary"
              onClick={onGiveFeedback}
            >
              Dar feedback
            </button>
          </div>
        )}
      </>
    )}
    {state === 'done' && feedback && (
      <div className="vd-grid">
        <Field label="Tipología">{modelName}</Field>
        <Field label="Intención de compra">
          {optionLabel(PURCHASE_INTENT_OPTIONS, feedback.purchase_intent)}
        </Field>
        <Field label="Etapa del prospecto">
          {optionLabel(PROSPECT_STAGE_OPTIONS, feedback.prospect_stage)}
        </Field>
        <Field label="Comparó con">{feedback.compared_with}</Field>
        <Field label="Objeciones">
          {feedback.objections?.length
            ? feedback.objections
                .map((value) => optionLabel(OBJECTION_OPTIONS, value))
                .join(', ')
            : ''}
        </Field>
      </div>
    )}
  </section>
);

export default PreSaleFeedbackCard;
